module.exports = __webpack_public_path__ + "img/home-hero.24f43260.png";